(function () {

  function ensureStyle() {
    if (document.getElementById('only-last-reco-style')) return;
    const style = document.createElement('style');
    style.id = 'only-last-reco-style';
    style.textContent = `
      .f-cart-recommendations[data-only-last="hide"] { display: none !important; }
      .f-cart-recommendations[data-only-last="show"] { display: block !important; }
    `;
    document.head.appendChild(style);
  }

  function apply() {
    ensureStyle();

    const all = document.querySelectorAll('.f-cart-recommendations');
    if (!all.length) return;


    all.forEach(el => {
      el.setAttribute('data-only-last', 'hide');
    });


    all[all.length - 1].setAttribute('data-only-last', 'show');
  }


  apply();
  setTimeout(apply, 250);
  setTimeout(apply, 1000);
  setTimeout(apply, 2000);

  const obs = new MutationObserver(() => apply());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  console.log('[only-last-reco] loaded');
})();